export default {
  props: {
    level: {
      type: Number,
      default: 0
    },
    isAudioLevel: {
      type: Boolean,
      default() {
        return true;
      }
    }
  }
};